import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinus = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.16699 11H11.0003H13.0003H17.8337C18.3859 11 18.8337 11.4477 18.8337 12C18.8337 12.5523 18.3859 13 17.8337 13H13.0003H11.0003H6.16699C5.61471 13 5.16699 12.5523 5.16699 12C5.16699 11.4477 5.61471 11 6.16699 11Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
